import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Thumbnail from "@/components/Thumbnail/Thumbnail.vue";
import {PlantingPlanIds, PlantingWorkItemPlanInCalendarDetail, RecordImage} from '@/types';

type PlantingInCalendar = {
    id: string, // 作付のID
    name: string, // 作付の名前
    agri_fields: [ // 登録圃場のリスト
        {
            id: string, // 圃場のID
            name: string, // 圃場の名前
            planted_area: number
        }
    ]
};

@Component({
    components: {
        Thumbnail,
    }
})
export default class CalendarDetailWorkPlan extends Vue {

    @Prop({ default: {plantingId: "", workItemId: ""}})
    private selectedPlantingPlanIds!: PlantingPlanIds;

    private selectedPlantingWorkItemPlan: PlantingWorkItemPlanInCalendarDetail = {
        work_item_id: "",
        name: "",
        plan_type: "",
        working_start_date: "",
        working_end_date: "",
        selected_work_item_id: "",
        days: 0,
        ago_or_later: "",
        setting_type: "",
        total_time: 0,
        per_type: 'total',
        attention_point: "",
        image_id: [],
        time_allocation: [
            {
                working_period: "",
                working_hour: 0
            }
        ]
    };

    private recordImages: RecordImage[] = [];
    private selectedPlating: PlantingInCalendar = {
        id: "",
        name: "",
        agri_fields: [
            {
                id: "",
                name: "",
                planted_area: 0
            }
        ]
    };
    private actualWorkTime = 0;

    private get totalFieldsArea(): number {
       return this.selectedPlating.agri_fields.reduce((before, current) => {
           return before + current.planted_area;
        }, 0);
    }


    private get plannedWorkTime(): number | string {
        if(this.selectedPlantingWorkItemPlan.per_type === '10a' && this.selectedPlantingWorkItemPlan.total_time) {
            const rate = Math.floor(this.totalFieldsArea) / 10;
            return this.selectedPlantingWorkItemPlan.total_time * rate;
        } else if(this.selectedPlantingWorkItemPlan.per_type === 'total' && this.selectedPlantingWorkItemPlan.total_time) {
            return this.selectedPlantingWorkItemPlan.total_time;
        } else {
            return '-';
        }
    }


    @Watch('selectedPlantingPlanIds', {immediate: true})
    private changePlantingPlanId() {
        this.recordImages = [];
        if(this.selectedPlantingPlanIds) {
            this.$apiClient.doRequest('get', `/plantings/${this.selectedPlantingPlanIds.plantingId}/plans/${this.selectedPlantingPlanIds.workItemId}`).then((ret) => {
                if (ret.image_id.length) {
                    ret.image_id.forEach((imageId: string) => {
                        this.$apiClient.doRequest('get', `/harvest_records/${ret.id}/images/${imageId}`).then((ret: RecordImage) => {
                            ret.record_id = ret.id;
                            this.recordImages.push(ret);
                        });
                    });
                }
                this.selectedPlantingWorkItemPlan = ret;
            });
            this.$apiClient.doRequest('get', `/plantings/${this.selectedPlantingPlanIds.plantingId}`).then((ret) => {
                this.selectedPlating = {id: ret.id, name: ret.name, agri_fields: ret.agri_fields};
            });
            this.$apiClient.doRequest('get', `/work_records/actual/sum?planting_id=${this.selectedPlantingPlanIds.plantingId}&work_item_id=${this.selectedPlantingPlanIds.workItemId}`).then((ret) => {
                this.actualWorkTime = ret.work_time;
            });
        }

    }
}